import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';

const ContainerWithLogo = ({ children, titleLabel }) => (
  <Container>
    <Link to={RouterConstants.HOME}>
      <Logo src="/images/logo.png" alt="logo" />
    </Link>
    {
      titleLabel && (
        <h2>
          <FormattedMessage id={titleLabel} />
        </h2>
      )
    }
    {children}
  </Container>
);

ContainerWithLogo.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  titleLabel: PropTypes.string,
};

ContainerWithLogo.defaultProps = {
  children: null,
  titleLabel: '',
};

const Container = styled.div`
  background : -webkit-linear-gradient(90deg, ${colors.SEAGULL} 0%, ${colors.JAVA} 100%);
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 20px 0 0;
`;

const Logo = styled.img`
  width: 200px;
  margin-top: 30px;
  cursor: pointer;
  @media (max-width: 650px) {
    width: 150px;
  }
`;

export default ContainerWithLogo;
